/* eslint-disable import/no-cycle */
/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import firebase from 'firebase';
import { connect } from 'react-redux';
import { setUserData } from './core/redux/auth';
import { getUserRoles } from './core/userRoles';

import About from './pages/About/About';
import Exams from './pages/Exams/Exams';
import Logout from './pages/Logout/Logout';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import Profile from './pages/Profile/Profile';
import RecoverPassword from './pages/RecoverPassword/RecoverPassword';
import SignIn from './pages/SignIn/SignIn';
import SignUp from './pages/SignUp/SignUp';
import Users from './pages/Users/Users';
import NotFound from './pages/NotFound/NotFound';
import PrivateRoute from './core/router';
import Import from './pages/Import';
import Companies from './pages/Companies';
import { urls } from './core/utils/constants';

function mapDispatchToProps(dispatch) {
  return {
    setUserData: (uid, fullname, email, roles, isLoading) => {
      dispatch(setUserData(uid, fullname, email, roles, isLoading));
    },
  };
}

class ConnectedRoutes extends Component {
  constructor(props) {
    super(props);
    this.onAuthStateChanged = this.onAuthStateChanged.bind(this);
  }

  componentDidMount() {
    firebase.auth().onAuthStateChanged(this.onAuthStateChanged);
  }

  async onAuthStateChanged(user) {
    const { setUserData } = this.props;
    if (user) {
      const roles = await getUserRoles(user.uid);
      setUserData(user.uid, user.displayName, user.email, roles, false);
    } else {
      setUserData('', '', '', [], false);
    }
  }

  render() {
    return (
      <BrowserRouter basename="/">
        {/* A <Switch> looks through its children <Route>s and
              renders the first one that matches the current URL. */}
        <Switch>
          <Route exact path={urls.about.path} component={About} />
          <Route
            path={urls.dashboard.path}
            component={() => {
              // eslint-disable-next-line max-len
              window.location.href = 'http://ec2-52-90-241-95.compute-1.amazonaws.com/dashboard/c0d60b70-7509-11ea-bfb0-f56675d00801';
              return null;
            }}
          />
          <PrivateRoute exact path={urls.exams.path} component={Exams} {...this.props} />
          <PrivateRoute exact path={urls.root.path} component={Exams} {...this.props} />
          <PrivateRoute exact path={urls.companies.path} component={Companies} {...this.props} />
          <PrivateRoute exact path={urls.import.path} component={Import} {...this.props} />
          <Route exact path={urls.logout.path}>
            <Logout {...this.props} />
          </Route>
          <Route exact path={urls.privacy.path} component={PrivacyPolicy} />
          <PrivateRoute exact path={urls.profile.path} component={Profile} />
          <Route exact path={urls.recover.path}>
            <RecoverPassword {...this.props} />
          </Route>
          <Route exact path={urls.signin.path}>
            <SignIn {...this.props} />
          </Route>
          <Route exact path={urls.signup.path}>
            <SignUp {...this.props} />
          </Route>
          <PrivateRoute exact path={urls.users.path} component={Users} />
          <Route component={NotFound} />
        </Switch>
      </BrowserRouter>
    );
  }
}
ConnectedRoutes.propTypes = {
  setUserData: PropTypes.func.isRequired,
};

const Routes = connect(null, mapDispatchToProps)(ConnectedRoutes);

export default Routes;
